import { render, staticRenderFns } from "./RomainSimonDropdown.vue?vue&type=template&id=5e9e8e34&scoped=true"
import script from "./RomainSimonDropdown.vue?vue&type=script&lang=js"
export * from "./RomainSimonDropdown.vue?vue&type=script&lang=js"
import style0 from "./RomainSimonDropdown.vue?vue&type=style&index=0&id=5e9e8e34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e8e34",
  null
  
)

export default component.exports